import React, { Component } from 'react';
import { Table, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { validateAccess } from '../../session';
import { eventActions } from '../../webapi';
import { eventsLoaded, removeEvent } from '../../actions';
import { InputGroup, FilterMenu, Button, ExportCsvPopup, Popup, CheckBox } from '../../components';
import { COLOUR_BRANDING_ACTION, COLOUR_BRANDING_OFF, COLOUR_BRANDING_MAIN, getEventTimes } from '../../js';
import { withPay } from '../../payment';
import EventCalendar from './EventCalendar';
import { Text } from '../../components/text';
import { ENABLE_EVENT_PRINT } from '../../config';

const EXPORT_COLUMNS = [
  { label: 'Select All', key: '' },
  { label: 'Id', key: 'Id' },
  { label: 'Title', key: 'Title', selected: true },
  { label: 'Description', key: 'Description' },
  { label: 'Location', key: 'Location', selected: true },
  { label: 'Attendance Limit', key: 'TicketCount', selected: true },
  { label: 'Attendance Count', key: 'AttendanceCount', selected: true },
  { label: 'Date', key: 'Date', selected: true },
  { label: 'Time', key: 'Time', selected: true },
  { label: 'End Time', key: 'EndTime', selected: true },
  { label: 'ISO 8601 Timestamp', key: 'Timestamp' },
];

class ListEvents extends Component {
  state = {
    events: [],
    upcomingEvents: [],
    pastEvents: [],
    sortColumn: 'StartTime', // column to sort by
    sortDesc: false, // if true, sort descending rather than ascending
    now: moment.utc(),
    onlyFuture: true,
    search: '',
    exportCsvOpen: false,
    calendarYear: null,
    calendarMonth: null,
    calendarUrl: null,
    printingCalendar: false,
    excludeOutsideDates: true,
    weekStartsOnMonday: false,
    calendarGenerationStep: 'config', // 'config', 'generating', 'complete'
    currentWeekStart: moment().startOf('week'), // Track current week for week view
  };

  componentDidMount() {
    this.updateProps(this.props);
    this.checkLoadEvents();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  checkLoadEvents = () => {
    if (Object.keys(this.props.events).length > 0) {
      var maxElem = _.maxBy(this.props.events, (event) => {
        if (!event) {
          return 0;
        }
        return event.Changed;
      });
      this.loadEvents(maxElem.Changed + 1);
    } else {
      this.loadEvents();
    }
  };

  updateProps(props) {
    const events = [];

    props.events.forEach((ev) => {
      if (ev != null && !ev.Deleted) {
        events.push(ev);
      }
    });

    const upcomingEvents = _.filter(events, (ev) => {
      if (ev.IsEveryday) {
        return true;
      }
      if (ev.RepeatedTimes) {
        if (
          _.some(ev.RepeatedTimes, (rep) => {
            return moment.utc(rep.Time).isSameOrAfter(this.state.now);
          })
        ) {
          return true;
        }
        return false;
      }
      return (
        moment.utc(ev.StartTime).isSameOrAfter(this.state.now) ||
        (ev.EndTime != null && ev.EndTime !== '' && moment.utc(ev.EndTime).isSameOrAfter(this.state.now))
      );
    });

    const pastEvents = _.reject(events, (item) =>
      _.find(upcomingEvents, (t) => {
        return t.Id === item.Id;
      }),
    );

    upcomingEvents.forEach((e) => {
      if (e.RepeatedTimes) {
        e.Upcomings = [];
        e.RepeatedTimes.forEach((rep) => {
          if (moment.utc(rep.Time).isSameOrAfter(this.state.now)) {
            e.Upcomings.push(rep);
          }
        });
        e.Upcomings = _.sortBy(e.Upcomings, (repetition) => {
          return moment(repetition.Time).valueOf();
        });
      }
    });

    this.setState({ events, upcomingEvents, pastEvents });
  }

  handleCheckChange(event) {
    var stateChange = {};
    stateChange[event.target.getAttribute('id')] = event.target.checked;
    this.setState(stateChange);
  }

  handleChange(event) {
    var stateChange = {};
    stateChange[event.target.getAttribute('id')] = event.target.value;
    this.setState(stateChange);
  }

  sortByCol(col) {
    if (this.state.sortColumn === col) {
      this.setState({
        sortDesc: !this.state.sortDesc,
      });
    } else {
      this.setState({
        sortColumn: col,
        sortDesc: false,
      });
    }
  }

  hasAttendance = (event) => {
    return (
      event.RepeatedTimes &&
      event.RepeatedTimes.some((t) => {
        return t.AttendanceCount && t.AttendanceCount > 0;
      })
    );
  };

  removeEvent(event) {
    if (this.props.payment.hasPaymentInfo(event) && this.hasAttendance(event)) {
      window.alert(`There are tickets already purchased for ${event.Title}. Please refund the tickets first.`);
      return;
    }

    if (window.confirm(`Are you sure you want to delete ${event.Title}?`)) {
      this.props.removeEvent(event.RowId);
      eventActions
        .removeEvent(this.props.auth.site, event.RowId)
        .then((res) => {
          // action
        })
        .catch((res) => {
          alert('Something went wrong with the request. Please try again.');
        });
    }
  }

  loadEvents(time) {
    this.setState({
      loading: true,
    });

    eventActions
      .getEventsRecursive(this.props.auth.site, time, true)
      .then((res) => {
        this.setState({
          loading: false,
        });
        if (res.data != null && !_.isEmpty(res.data) && res.data[0].Site === this.props.auth.site) {
          this.props.eventsLoaded(res.data);
          setTimeout(() => {
            this.checkLoadEvents();
          }, 2000);
        }
      })
      .catch((res) => {
        this.setState({ loading: false });
        alert('Something went wrong with the request. Please try again.');
      });
  }

  onOpenExportCsv = () => {
    this.setState({ exportCsvOpen: true });
  };

  onCloseExportCsv = () => {
    this.setState({ exportCsvOpen: false });
  };

  onChangeMonth = (year, month) => {
    this.setState({ calendarYear: year, calendarMonth: month });
  };

  onChangeWeek = (weekStart) => {
    this.setState({ currentWeekStart: weekStart });
  };

  onPrintCalendar = () => {
    this.setState({ printingCalendar: true, calendarUrl: null, calendarGenerationStep: 'config' });
  };

  onStartGeneration = () => {
    this.setState({ calendarGenerationStep: 'generating' }, this.onGenerateCalendar);
  };

  onChangeWeek = (weekStart) => {
    this.setState({ currentWeekStart: weekStart });
  };

  onGenerateCalendar = async () => {
    try {
      const { calendarYear, calendarMonth, excludeOutsideDates, weekStartsOnMonday } = this.state;
      const { data } = await eventActions.generateCalendar(
        this.props.auth.site,
        calendarMonth,
        calendarYear,
        0,
        excludeOutsideDates,
        weekStartsOnMonday,
      );
      // console.log('onPrintCalendar', data);
      this.setState({ calendarUrl: data.fileUrl, calendarGenerationStep: 'complete' });
    } catch (error) {
      this.setState({ printingCalendar: false, calendarGenerationStep: 'config' });
      console.log('onPrintCalendar - error', error);
      alert('Something went wrong with the request. Please try again.');
    }
  };

  onToggleExcludeOutsideDates = () => {
    this.setState({ excludeOutsideDates: !this.state.excludeOutsideDates });
  };

  onToggleWeekStartDay = () => {
    this.setState({ weekStartsOnMonday: !this.state.weekStartsOnMonday });
  };

  getExportDateRange = () => {
    // Return appropriate date range based on current view
    if (this.props.viewType === 'calendar' && this.state.calendarMonth && this.state.calendarYear) {
      // For calendar view, use the displayed month
      const startDate = moment()
        .year(this.state.calendarYear)
        .month(this.state.calendarMonth - 1)
        .startOf('month');
      const endDate = moment()
        .year(this.state.calendarYear)
        .month(this.state.calendarMonth - 1)
        .endOf('month');
      return { startDate, endDate };
    } else if (this.props.viewType === 'week' && this.state.currentWeekStart) {
      // For week view, use the displayed week
      const startDate = moment(this.state.currentWeekStart).startOf('week');
      const endDate = moment(this.state.currentWeekStart).endOf('week');
      return { startDate, endDate };
    } else {
      // For list view, default to current week
      return { startDate: moment().startOf('w'), endDate: moment().endOf('w') };
    }
  };

  getExportSource = () => {
    return getEventTimes(this.state.events).map((ev) => {
      // Format EndTime using moment for consistency
      let formattedEndTime = null;
      if (ev.EndTime) {
        // Parse the time string (e.g., "6pm" or "6:30pm") and format to h:mma
        const timeMoment = moment(ev.EndTime, ['ha', 'h:mma']);
        formattedEndTime = timeMoment.isValid() ? timeMoment.format('h:mma') : ev.EndTime;
      }

      return {
        Id: ev.EntryId,
        Title: ev.Title,
        Description: ev.Description || '',
        Location: ev.Location,
        TicketCount: ev.TicketCount === 0 ? null : ev.TicketCount,
        AttendanceCount: ev.AttendanceCount,
        Date: moment.utc(ev.TimeSort).local().format('DD/MM/YYYY'),
        Time: ev.AllDay ? 'All Day' : moment.utc(ev.TimeSort).local().format('h:mma'),
        EndTime: formattedEndTime,
        Timestamp: moment.utc(ev.TimeSort).local().format(),
        TimestampValue: ev.TimeSort,
      };
    });
  };

  getTime(event) {
    const isAllDay = (event.RepeatedTimes.length > 0 && event.RepeatedTimes[0].AllDay) || event.AllDay;

    if (event.IsEveryday) {
      return 'Facility / Everyday event';
    }
    if (!_.isEmpty(event.Upcomings)) {
      let secondLine = null;
      const result = moment
        .utc(event.Upcomings[0].Time)
        .local()
        .format(isAllDay ? 'D MMM YY' : 'D MMM YY - h:mma');
      if (event.Upcomings.length === 2) {
        secondLine = '+ 1 more time slot';
      } else if (event.Upcomings.length > 2) {
        secondLine = `+ ${event.Upcomings.length - 1} more time slots`;
      }
      if (secondLine) {
        return (
          <span>
            {result}
            <br />
            {secondLine}
          </span>
        );
      }
      return result;
    }
    if (!_.isEmpty(event.RepeatedTimes) && _.isEmpty(event.Upcomings)) {
      return 'No upcoming dates';
    }
    return moment
      .utc(event.StartTime)
      .local()
      .format(isAllDay ? 'D MMM YY' : 'D MMM YY - h:mma');
  }

  renderFull(reps) {
    if (!reps) {
      return null;
    }
    const filledEvents = _.filter(reps, (rep) => {
      return (
        moment.utc(rep.Time).isSameOrAfter(this.state.now) &&
        rep.TicketCount &&
        rep.AttendanceCount &&
        rep.AttendanceCount >= rep.TicketCount
      );
    });
    if (filledEvents.length === 0) {
      return null;
    }
    return (
      <span
        style={{
          backgroundColor: COLOUR_BRANDING_OFF,
          marginLeft: 15,
          paddingTop: 3,
          paddingBottom: 3,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 3,
          color: COLOUR_BRANDING_MAIN,
          fontSize: 11,
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          height: 'fit-content',
          alignSelf: 'center',
        }}
      >
        {filledEvents.length} full event{filledEvents.length > 1 ? 's' : ''}
      </span>
    );
  }

  renderEvents(source) {
    if (!_.isEmpty(this.state.search)) {
      source = _.filter(source, (ev) => {
        return ev.Title.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1;
      });
    }

    return source.map((ev) => {
      if (ev != null) {
        return (
          <tr key={ev.RowId}>
            <td className="table-TitleColumn">
              <Link to={`/events/event/${ev.RowId}`}>
                <span>
                  {this.props.payment.hasPaymentInfo(ev) && <FontAwesome style={{ color: COLOUR_BRANDING_ACTION }} name="usd fa-fw" />}
                  {ev.Title}
                </span>
              </Link>
              {this.renderFull(ev.RepeatedTimes)}
            </td>
            <td>{this.getTime(ev)}</td>
            <td className="table-options">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {validateAccess(this.props.auth.site, 'comments', this.props.auth) && (
                  <Link
                    to={`/comments/thread/${ev.Id}_event`}
                    onClick={() => {
                      sessionStorage.setItem('eventsReturnView', this.props.viewType || 'calendar');
                    }}
                  >
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 12,
                        cursor: 'pointer',
                      }}
                      name="comment"
                    />
                  </Link>
                )}
                {validateAccess(this.props.auth.site, 'events', this.props.auth) && (
                  <Link to={`/events/analytics/${ev.RowId}`}>
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 12,
                        cursor: 'pointer',
                      }}
                      name="bar-chart"
                    />
                  </Link>
                )}
                {validateAccess(this.props.auth.site, 'events', this.props.auth) && (
                  <Link to={`/events/event/${ev.RowId}`}>
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 12,
                        cursor: 'pointer',
                      }}
                      name="pencil"
                    />
                  </Link>
                )}
                {validateAccess(this.props.auth.site, 'events', this.props.auth) && (
                  <a
                    onClick={() => {
                      this.removeEvent(ev);
                    }}
                  >
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 8,
                        cursor: 'pointer',
                      }}
                      name="minus-circle"
                    />
                  </a>
                )}
              </div>
            </td>
          </tr>
        );
      }
      return null;
    });
  }

  renderSort(col) {
    if (col !== this.state.sortColumn) {
      return null;
    }
    return <FontAwesome style={{ marginLeft: 5 }} name={this.state.sortDesc ? 'chevron-up' : 'chevron-down'} />;
  }

  sortIsActive(col) {
    if (col !== this.state.sortColumn) {
      return '';
    }
    return ' table--columnActive';
  }

  renderView(source) {
    return (
      <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
        <thead>
          <tr>
            <th
              className={`${this.sortIsActive('Title')}`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.sortByCol('Title');
              }}
            >
              Event{this.renderSort('Title')}
            </th>
            <th
              className={`${this.sortIsActive('StartTime')}`}
              style={{ cursor: 'pointer', width: 200 }}
              onClick={() => {
                this.sortByCol('StartTime');
              }}
            >
              Date{this.renderSort('StartTime')}
            </th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>{this.renderEvents(source)}</tbody>
      </Table>
    );
  }

  renderEmpty() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 32,
        }}
      >
        <div className="emptyState" />
        <div className="marginTop-32" style={{ maxWidth: 500, textAlign: 'center' }}>
          <Text type="h3">There are no events</Text>
        </div>
      </div>
    );
  }

  renderCalendar() {
    return (
      <EventCalendar
        auth={this.props.auth}
        eventList={getEventTimes(this.state.events)}
        selectDate={this.props.selectDate}
        selectedDate={this.props.selectedDate}
        view={this.props.viewType}
        changeMonth={this.onChangeMonth}
        changeWeek={this.onChangeWeek}
      />
    );
  }

  renderContent() {
    if (this.props.viewType === 'calendar' || this.props.viewType === 'week') {
      return this.renderCalendar();
    }
    let source = this.state.events;
    if (this.props.filterOption === 'upcoming') {
      source = this.state.upcomingEvents;
    }
    if (this.props.filterOption === 'past') {
      source = this.state.pastEvents;
    }

    source = _.sortBy(source, (event) => {
      if (this.state.sortColumn !== 'StartTime') {
        return event[this.state.sortColumn];
      }
      if (!_.isEmpty(event.RepeatedTimes)) {
        return event.RepeatedTimes[0].Time;
      }
      return event.StartTime;
    });
    if (this.state.sortDesc) {
      source.reverse();
    }
    // source = []
    if (_.isEmpty(source)) {
      return this.renderEmpty();
    }
    return this.renderView(source);
  }

  renderSearch() {
    if (this.props.viewType === 'calendar' || this.props.viewType === 'week') {
      return null;
    }
    return (
      <Row className="show-grid">
        <Col xs={6}>
          <InputGroup
            id={`search`}
            type="text"
            label="Search"
            placeholder="Search by event's title."
            value={this.state.search}
            onChange={(e) => this.handleChange(e)}
            autoComplete={false}
          />
        </Col>
      </Row>
    );
  }

  renderCSVPopup() {
    if (!this.state.exportCsvOpen) {
      return null;
    }
    const dateRange = this.getExportDateRange();
    return (
      <ExportCsvPopup
        onClose={this.onCloseExportCsv}
        columns={EXPORT_COLUMNS}
        source={this.getExportSource()}
        filename="events.csv"
        timestampFilter={{ filterKey: 'TimestampValue', startDate: dateRange.startDate, endDate: dateRange.endDate }}
      />
    );
  }

  renderPrintPopup() {
    const { printingCalendar, calendarUrl, excludeOutsideDates, weekStartsOnMonday, calendarGenerationStep } = this.state;
    if (!printingCalendar) return null;

    const onClose = () => this.setState({ printingCalendar: false, calendarUrl: null, calendarGenerationStep: 'config' });
    const onDownload = () => window.open(calendarUrl, '_blank');

    // Step 1: Configuration
    if (calendarGenerationStep === 'config') {
      return (
        <Popup
          title="Generate Printable Calendar"
          minWidth={500}
          minHeight={250}
          hasPadding
          onClose={onClose}
          buttons={[
            {
              type: 'tertiary',
              onClick: onClose,
              isActive: true,
              text: 'Cancel',
            },
            {
              type: 'primary',
              onClick: this.onStartGeneration,
              isActive: true,
              text: 'Generate Calendar',
            },
          ]}
        >
          <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 16 }}>
              <CheckBox
                label="Exclude dates outside selected month"
                isActive={excludeOutsideDates}
                onChange={this.onToggleExcludeOutsideDates}
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <CheckBox label="Start week on Monday" isActive={weekStartsOnMonday} onChange={this.onToggleWeekStartDay} />
            </div>
            <Text type="body">
              This will generate a PDF calendar for{' '}
              {this.state.calendarMonth && this.state.calendarYear
                ? `${moment()
                    .month(this.state.calendarMonth - 1)
                    .format('MMMM')} ${this.state.calendarYear}`
                : 'the selected month'}{' '}
              with all scheduled events.
            </Text>
          </div>
        </Popup>
      );
    }

    // Step 2: Generation in progress
    if (calendarGenerationStep === 'generating') {
      return (
        <Popup
          title="Creating Printable Calendar"
          minWidth={500}
          minHeight={200}
          hasPadding
          onClose={null} // Prevent closing while generating
        >
          <div className="flex flex-column flex-center marginTop-16">
            <FontAwesome name="spinner fa-pulse fa-fw" style={{ fontSize: 32, color: COLOUR_BRANDING_OFF }} />
            <Text type="body">Generating your calendar PDF...</Text>
          </div>
        </Popup>
      );
    }

    // Step 3: Complete - ready to download
    if (calendarGenerationStep === 'complete') {
      return (
        <Popup
          title="Printable Calendar Ready"
          minWidth={500}
          minHeight={200}
          hasPadding
          onClose={onClose}
          buttons={[
            {
              type: 'tertiary',
              onClick: onClose,
              isActive: true,
              text: 'Close',
            },
            {
              type: 'primary',
              onClick: onDownload,
              isActive: true,
              text: 'Download PDF',
              leftIcon: 'download',
            },
          ]}
        >
          <div className="flex flex-column flex-center marginTop-16">
            <Text type="body">Your calendar PDF has been generated and is ready for download.</Text>
          </div>
        </Popup>
      );
    }

    return null;
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        {this.renderCSVPopup()}
        {this.renderPrintPopup()}
        <FilterMenu
          filteredBy={this.state.sortColumn}
          sortDesc={this.state.sortDesc}
          alphaSortKey="Title"
          alphaSort={this.sortByCol.bind(this, 'Title')}
          timeSortKey="StartTime"
          timeSort={this.sortByCol.bind(this, 'StartTime')}
          viewType={this.props.viewType}
          updateView={this.props.updateView.bind(this)}
          showCalendar={this.props.filterOption === 'all'}
        >
          <div className="userTypesButtonContainer userTypesButtonContainer-noTop marginRight-20">
            <Button inline buttonType="primaryAction" onClick={this.onOpenExportCsv} isActive>
              <div className="buttonInner">
                <FontAwesome name="file-code-o" style={{ fontSize: 19 }} />
                <div className="text">Export CSV</div>
              </div>
            </Button>
            {this.props.viewType === 'calendar' && ENABLE_EVENT_PRINT ? (
              <Button inline buttonType="primaryAction" onClick={this.onPrintCalendar} isActive className="marginRight-20">
                <div className="buttonInner">
                  <FontAwesome name="print" style={{ fontSize: 19 }} />
                  <div className="text">Print (Beta)</div>
                </div>
              </Button>
            ) : null}
          </div>
        </FilterMenu>
        {this.renderSearch()}
        {this.renderContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { events } = state.events;
  const { auth } = state;
  return { events, auth: auth };
};

export default withPay(connect(mapStateToProps, { eventsLoaded, removeEvent })(ListEvents));
